import * as React from 'react';
import classNames from 'classnames';
import {Flex, Icon, IconType} from 'components/UIKit';
import style from './circle-icon.scss';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface CircleIconProps extends DivElementProps {
  icon: IconType;
  size?: number;
  fill?: string;
}

export function CircleIcon({
  icon,
  fill,
  size = 24,
  style: styleProp,
  className,
  ...restProps
}: CircleIconProps) {
  const innerIconSize = size * 0.4;
  const wrapStyle = {width: size, height: size, ...styleProp};

  return (
    <Flex
      style={wrapStyle}
      className={classNames(className, style.wrap)}
      alignItems="center"
      justifyContent="center"
      {...restProps}
    >
      <Icon icon={icon} size={innerIconSize} fill={fill || 'purple'} />
    </Flex>
  );
}
